module.exports = __webpack_public_path__ + "img/V.80a143de.gif";